export const ProjectData = [
  {
    title: "Assembly Endgame",
    description:
      "A word-guessing game where each wrong guess eliminates a programming language, until only Assembly is left.",
    stack: "HTML, CSS, React.js, Typescript",
    repo: "https://github.com/Birdie13-stack/assembly-endgame-ts",
    live: "https://assembly-endgame-ts.vercel.app/",
  },

  {
    title: "Tenzies Game",
    description:
      "A dice game where you roll and hold dice until all show the same number. Built with game logic and state management.",
    stack: "React.js, CSS",
    repo: "https://github.com/Birdie13-stack/tenzies",
    live: "https://tenzies-red-eta.vercel.app/",
  },

  {
    title: "Password Generator",
    description:
      "A password generator that creates secure, random passwords based on your chosen length.",
    stack: "React.js, CSS",
    repo: "https://github.com/Birdie13-stack/password-generator",
    live: "https://password-generator-neon-one.vercel.app/",
  },

  // {
  //   title: "Advice Generator",
  //   description: "A random advice generator using the advice slip API.",
  //   stack: "HTML, CSS, React.js",
  //   repo: "https://github.com/Birdie13-stack/advice-gen",
  //   live: " https://advice-gen-sage.vercel.app/",
  // },

  {
    title: "Movie Discovery",
    description:
      "A movie discovery web application showing movie details using the TMDB API.",
    stack: "HTML, CSS, React.js",
    repo: "https://github.com/Birdie13-stack/HNGtask2,",
    live: "https://hng-task2-six.vercel.app/ ",
  },

  {
    title: "Meme Generator",
    description:
      "A meme generator that lets you select an image and add custom text.",
    stack: "HTML, CSS, React.js",
    repo: "https://github.com/Birdie13-stack/meme-generator",
    live: "https://meme-generator-seven-tau.vercel.app/",
  },

  {
    title: "Quote Generator",
    description: "An random quote generator using the API Ninjas Quote API.",
    stack: "React.js, CSS",
    repo: "https://github.com/Birdie13-stack/quote-generator ",
    live: "https://quote-generator-nine-sigma.vercel.app/",
  },

  {
    title: "Photo Gallery",
    description:
      "A photo gallery that fetches and displays random phots from the Unsplash API",
    stack: "React.js, CSS",
    repo: "https://github.com/Birdie13-stack/photo-gallery",
    live: "https://photo-gallery-chi-opal.vercel.app/ ",
  },
];
